import type { JSX } from 'react';

import { ThemeProvider } from '@change/ds-core-ui/next';

import { ClientRender } from '@change-corgi/core/react/ssr/render';

import {
	StarterDashboardV2BreakpointStateProvider,
	useStarterDashboardV2PageNotificationManagerContext,
} from 'src/app/pages/starterDashboardV2/pageContext';

import { PageBody } from '../components/PageBody';
import { PageHeader } from '../components/PageHeader';

import { useTrackPageView } from './hooks/useTrackPageView';

export function Layout(): JSX.Element {
	useTrackPageView();
	const {
		data: { notification },
	} = useStarterDashboardV2PageNotificationManagerContext();

	return (
		<ThemeProvider>
			{/* We depend on client breakpoints */}
			<ClientRender placeholder={<div className="h-16" />}>
				<StarterDashboardV2BreakpointStateProvider>
					<PageHeader />
					<div className="bg-fill-weaker h-full w-full">
						{notification?.content}
						<PageBody />
					</div>
				</StarterDashboardV2BreakpointStateProvider>
			</ClientRender>
		</ThemeProvider>
	);
}
